import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Link } from 'react-router';
import { Button } from '../../../Button/index.js';
import { FAIcon } from '../../../fa-icon/component.js';
import { formatClassName as _formatClassName } from '../../../../utils/formatClassName.js';

var ActionButton = function ActionButton(props) {
  var action = props.action,
      actionType = props.actionType,
      className = props.className,
      disabled = props.disabled,
      download = props.download,
      icon = props.icon,
      iconFamily = props.iconFamily,
      iconTransform = props.iconTransform,
      _props$keyField = props.keyField,
      keyField = _props$keyField === void 0 ? 'id' : _props$keyField,
      _props$LinkComponent = props.LinkComponent,
      LinkComponent = _props$LinkComponent === void 0 ? Link : _props$LinkComponent,
      _props$row = props.row,
      row = _props$row === void 0 ? {} : _props$row,
      showLabel = props.showLabel,
      target = props.target,
      _props$title = props.title,
      title = _props$title === void 0 ? '' : _props$title,
      tooltip = props.tooltip,
      type = props.type;

  var renderButtonWithTooltip = function renderButtonWithTooltip(renderedButton) {
    var tooltipId = "tooltip-".concat(title.toLowerCase(), "-").concat(row[keyField]);
    return /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "top",
      delay: 250,
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: tooltipId
      }, tooltip)
    }, /*#__PURE__*/React.createElement("span", null, renderedButton));
  };

  var renderButtonChildren = function renderButtonChildren() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FAIcon, {
      transform: iconTransform,
      icon: icon
    }), showLabel && /*#__PURE__*/React.createElement("span", {
      className: "action-label"
    }, title));
  };

  var preventClickThrough = function preventClickThrough(event) {
    if (!event) {
      return;
    }

    event.stopPropagation();
  };

  var preventAction = function preventAction(event) {
    event.preventDefault();
  };

  var renderButton = function renderButton() {
    var buttonChildren = renderButtonChildren();
    var dataAttributes = {
      'data-action': icon || type ? "".concat(icon || type, "-").concat(row.type) : '',
      'data-object-id': row && row.id,
      'data-object-type': row && row.type
    };
    var commonButtonProps = {
      style: 'link',
      icon: icon,
      iconFamily: iconFamily,

      /* i18next-extract-disable-next-line */
      label: showLabel ? title : undefined,
      className: _formatClassName(['m-r-10', className, {
        disabled: disabled
      }]),
      disabled: disabled,
      chakra: 'off'
    };
    var renderedButton;

    switch (actionType) {
      case 'link':
        renderedButton = /*#__PURE__*/React.createElement(LinkComponent, _extends({}, dataAttributes, {
          className: _formatClassName(['btn', 'btn-link', {
            disabled: disabled
          }, className]),
          download: download,
          onClick: disabled ? preventAction : preventClickThrough,
          target: target,
          to: action
        }), buttonChildren);
        break;

      case 'externalLink':
        renderedButton = /*#__PURE__*/React.createElement(Button, _extends({}, dataAttributes, commonButtonProps, {
          onClick: preventClickThrough,
          href: action,
          target: target,
          download: download,
          renderAsLegacy: true
        }));
        break;

      case 'callToAction':
        renderedButton = /*#__PURE__*/React.createElement(Button, _extends({}, dataAttributes, commonButtonProps, {
          onClick: function onClick(e) {
            preventClickThrough(e);
            action(e, row);
          },
          renderAsLegacy: true
        }));
        break;

      default:
        return null;
    }

    return tooltip ? renderButtonWithTooltip(renderedButton) : renderedButton;
  };

  return renderButton();
};

export { ActionButton };